export default __webpack_public_path__ + "static/media/readBlog.97919fb4.png";